import { FC, useContext, MouseEvent } from 'react';
import { AlertPanelWrapper, AlertPanelButtonLink } from './AlertPanel.styles';
import { Icon } from '@blueprint/ui';
import { SearchContext } from '../SearchContext';
import { AlertPanelSimpleProps } from './AlertPanel.types';

const editSavedSearchBtnText = 'Edit saved search';
const startNewSearchBtnText = 'Start a new search';
const turnOnEmailAlertBtnText = 'Turn on email alert';
const editEmailAlertBtnText = 'Edit email alert';

const AlertPanelSimple: FC<AlertPanelSimpleProps> = ({ onSimpleLinkClick }) => {
    const { state } = useContext(SearchContext);

    const { savedSearchAndAlerts, searchType } = state;

    const simpleLinkEditSearch = (evt: MouseEvent<HTMLElement>) => {
        onSimpleLinkClick &&
            onSimpleLinkClick(evt, 'search results', 'edit_search', true);
    };

    const simpleLinkNewSearch = (evt: MouseEvent<HTMLElement>) => {
        onSimpleLinkClick &&
            onSimpleLinkClick(evt, 'search results', 'new_search');
    };

    const simpleLinkAlert = (evt: MouseEvent<HTMLElement>) => {
        onSimpleLinkClick &&
            onSimpleLinkClick(
                evt,
                'search results',
                savedSearchAndAlerts?.currentFrequency.value === ''
                    ? 'create_alert'
                    : 'edit_alert',
                true
            );
    };

    return (
        <AlertPanelWrapper
            color="graphic-background-accent-light"
            data-testid="saved-search-email-alert-button-panel"
        >
            <AlertPanelButtonLink
                variant="secondary"
                data-testid="edit-saved-search-button-link"
                data-url={savedSearchAndAlerts?.uri as string}
                isFullWidth
                onClick={simpleLinkEditSearch}
            >
                <Icon iconId="pencil" />
                {editSavedSearchBtnText}
            </AlertPanelButtonLink>

            <AlertPanelButtonLink
                variant="secondary"
                data-testid="start-new-search-button-link"
                data-url={`/${searchType}/`}
                isFullWidth
                onClick={simpleLinkNewSearch}
            >
                <Icon iconId="search" />
                {startNewSearchBtnText}
            </AlertPanelButtonLink>

            <AlertPanelButtonLink
                variant="secondary"
                data-testid="turn-on-edit-email-alert-button"
                data-url={savedSearchAndAlerts?.uri as string}
                isFullWidth
                onClick={simpleLinkAlert}
            >
                <Icon iconId="email_outline" />
                {savedSearchAndAlerts?.currentFrequency.value === ''
                    ? turnOnEmailAlertBtnText
                    : editEmailAlertBtnText}
            </AlertPanelButtonLink>
        </AlertPanelWrapper>
    );
};

export default AlertPanelSimple;
